import SettingsIcon from '@mui/icons-material/Settings';
import { useTheme } from '@mui/material';
import { IconButton, Stack, Typography } from 'common/components/material';
import { useDrawer, useRouter, useView } from 'common/hooks';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import { FeatureGuard } from 'features/feature-access/components/feature-guard.component';
import { FeaturesEnum } from 'features/feature-access/features.enum';
import { DrawerIdEnum } from 'features/org-root/enums/drawer-id.enum';
import { NOTIFICATION_HISTORY_DAY_COUNT } from 'features/notifications';

export const NotificationDrawerLabel: React.FC = () => {
  const { goTo } = useRouter();
  const { palette } = useTheme();
  const { closeDrawer } = useDrawer();
  const { isMobileView } = useView();
  const goToManageNotifications = () => {
    goTo(AppRoutesEnum.MANAGE_NOTIFICATIONS);
    closeDrawer(DrawerIdEnum.NOTIFICATION);
  };

  return (
    <Stack
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      width={'100%'}
    >
      <Stack
        direction="column"
        spacing={0}
        sx={{
          justifyContent: 'center',
          alignItems: 'flex-start',
          pt: 2,
          ml: 2,
          ...(isMobileView && { pb: 1 }),
        }}
      >
        <Typography
          variant={isMobileView ? 'h4' : 'h2'}
          fontWeight={700}
          color={palette.Text.Headline}
        >
          Notifications
        </Typography>
        <Typography
          variant={isMobileView ? 'body4' : 'body3'}
          fontWeight={300}
          color={palette.Text.SubtleText}
        >
          Activities from the past {NOTIFICATION_HISTORY_DAY_COUNT} days
        </Typography>
      </Stack>
      <Stack justifyItems={'right'} justifyContent={'right'}>
        <FeatureGuard features={[{ feature: FeaturesEnum.MANAGE_NOTIFICATIONS }]}>
          <IconButton
            sx={{ color: palette.Icons.Tertiary.IconFillDefault }}
            onClick={goToManageNotifications}
          >
            <SettingsIcon />
          </IconButton>
        </FeatureGuard>
      </Stack>
    </Stack>
  );
};
